// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1C1WC","title":"FrontImage_title__3OJJY"};